import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Fraunces, Geist_Mono, Nunito_Sans } from 'next/font/google'
import { SettingsProvider } from '@/components/providers/settings-provider'
import { ShopProvider } from '@/components/providers/shop-provider'
import { AdminToastProvider } from '@/components/admin/admin-ui'
import { CartDrawer } from '@/components/shop/cart-drawer'
import { SearchDialog } from '@/components/shop/search-dialog'
import { ShopToaster } from '@/components/shop/shop-toaster'

const sans = Nunito_Sans({
    subsets: ['latin']
})

const heading = Fraunces({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    axes: ['SOFT', 'opsz']
})

const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <SettingsProvider settings={pageProps?.settings ?? null}>
            <ShopProvider>
                <div className='h-full font-sans'>
                    <Head>
                        <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                        <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                    </Head>

                    <AdminToastProvider>
                        <Component {...pageProps} />
                    </AdminToastProvider>

                    <CartDrawer />
                    <SearchDialog />
                    <ShopToaster />
                </div>
            </ShopProvider>
        </SettingsProvider>
    )
}

export default App
